export default {
	methods: {
		$mx_alertSuccess(alert) {
			this.$toastr.s(alert)
		},

		$mx_alertThisOnSuccess(res) {
			if (res.data && res.data.msg) this.$toastr.s(res.data.msg)
		},

		$mx_alertError(alert) {
			this.$toastr.e(alert)
		},

		$mx_alertThisOnError(error) {
			if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
		},

		$mx_alertNotice(alert) {
			this.$toastr.w(alert)
		},

		$mx_alertThisOnNotice(res) {
			if (res.data && res.data.msg) this.$toastr.w(res.data.msg)
		},
	},
}
